import React, { forwardRef, useEffect, useState } from "react";
import moment from "moment";
import { IconButton, Typography } from "@mui/material";
import { Card } from "reactstrap";
import axios from "axios";

import { useSelector } from "react-redux";
import PrintIcon from "@mui/icons-material/Print";
import TableRowsVerificationUpload from "./payrollTableRowVerificationUpload";
import {
  HourMinFormat,
  HourMinLabelFormat,
  formatAmountDiv,
  getHMFromTime,
} from "../../../_helper/helper";
import CommonDataTableTimesheet from "./CommonDataTable";
import { LoadingPanel } from "../../../CommonComponents/CommonFunction";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import PrintReport from "./PrintReport";
import CloseIcon from "@mui/icons-material/Close";
import PaybreakModal from "./PaybreakModal";
import { Grid } from "@material-ui/core";
import { Icon } from "@progress/kendo-react-common";

export const d2Time = (date) => {
  return moment(date, "HH:mm:ss").format("HH:mm");
};
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  minHeight: "auto",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};
const PayrollContentVerification = forwardRef((props, ref) => {
  const {
    payPeriod,
    setIsLoading,
    isLoading,
    userId,
    price,
    rowsData,
    setRowsData,
    setOpenModalPrint,
    openModalPrint,
    userObject,
  } = props;

  // const [price, setPrice] = useState(0);
  const { role: selectedRole } = useSelector((state) => state.CommonReducer);
  const [summary, setSummary] = useState([]);
  const [totalinfo, setTotalinfo] = useState({
    jobtype: "Total",
    TotalHours: 0,
    Amount: 0,
  });
  axios.defaults.headers.common["Role"] = selectedRole;

  useEffect(() => {
    if (rowsData.length) {
      let RDOWithoutData = rowsData?.filter((item) => item.RDO !== "1");
      const SummaryData = RDOWithoutData.reduce((accumulator, currentItem) => {
        const existingItem = accumulator.find(
          (item) => item.jobtype === currentItem.jobtype
        );

        if (!existingItem) {
          accumulator.push({
            code: currentItem.code,
            jobtype: currentItem.jobtype,
            TotalHours: currentItem?.mn,
            Amount: parseFloat(currentItem.payAmount),
          });
        } else {
          existingItem.TotalHours += currentItem?.mn;
          existingItem.Amount += parseFloat(currentItem.payAmount);
        }

        return accumulator;
      }, []);
      let sumAmount = 0;
      let sumHours = 0;
      SummaryData.map((item) => {
        sumAmount += parseFloat(item.Amount);
        sumHours += item.TotalHours;
      });
      let totalinfod = {
        jobtype: "Total",
        TotalHours: sumHours,
        Amount: sumAmount,
      };
      setTotalinfo(totalinfod);
      let infoData = SummaryData;
      let sorted = infoData.sort((a, b) => {
        if (a.TotalHours > b.TotalHours) {
          return -1;
        } else if (a.TotalHours < b.TotalHours) {
          return 1;
        } else {
          // const workFromTimeA = moment(a.time_from, "HH:mm:ss");
          // const workFromTimeB = moment(b.time_from, "HH:mm:ss");
          // const workFromTimeComparison = workFromTimeA.diff(workFromTimeB);
          // if (workFromTimeComparison !== 0) {
          //   return workFromTimeComparison;
          // } else {

          // }
          return a.jobtype === "REG" ? -1 : 1;
        }
      });

      setSummary(sorted);
    }
  }, [rowsData]);
  const newBaseURL = process.env.REACT_APP_API_DOTNET_URL;
  const token =
    "Bearer eyJhbGciOiJSUzI1NiIsImtpZCI6IjdBQjAyMTU2OTcyQTRGQ0NENDVCQzc0Rjg4MjIyOTkwIiwidHlwIjoiYXQrand0In0.eyJuYmYiOjE3MTU3NzM3MTYsImV4cCI6MTcxNTg2MDExNiwiaXNzIjoiaHR0cHM6Ly9nZm1pcy1zaXQtaHJwLXNpZ25pbi5henVyZXdlYnNpdGVzLnVzIiwiYXVkIjoiYXBpMSIsImNsaWVudF9pZCI6Im15LWVocnB3ZWIiLCJzdWIiOiI4NjZjMzIyZS05YTU3LTQ0YmMtOWI3MS0yNGQ1MjllNThjNGUiLCJhdXRoX3RpbWUiOjE3MTU3NjY0MzIsImlkcCI6ImxvY2FsIiwicm9sZSI6InVzZXIiLCJuYW1lIjoiTGVvbiIsIkFwcGxpY2F0aW9uIjoiSFIiLCJFbXBsb3llZUlEIjoiNjMwODkiLCJlbWFpbCI6ImVtcGxvZWVAdWF0LmVocnB3ZWIuY29tIiwianRpIjoiQjgxMEMzNzQ5NTIwNDhCRTBCNjVDOTRBODY3MzczNkUiLCJzaWQiOiJFRENENDQ2NUVCNDQ5Q0FFQTI5OEZBQjcyOENBQTAyNiIsImlhdCI6MTcxNTc3MzcxNiwic2NvcGUiOlsib3BlbmlkIiwicHJvZmlsZSIsImVtYWlsIiwicm9sZXMiLCJhcGkxIl0sImFtciI6WyJwd2QiXX0.yaXq_AtKl_4-V_y7G7t58sVAt3m4rSb8J69p1r9CUR85kI4gfGVaLBPDgxmnfFL225-eRQfl8fPv-fOZoqOUfnccLykaNv158uo1LiCLm_ZyUodPy3eDQKQoVcocrIb8kejN8M46MVjDcPjuM26ESgBJlaF4NrWJjIVO_bgPFI-82WEwg38E_khnB90wZQF0L4rqG4b5AasaH_AL3Qbwa-o_ObXPcJI0QsI3x-bWlSmJftfyLaZYgGK2yHwsCCpm6bPh1iAdPMmyxkfbgqJrEgGkHdt4X5GFcMfm6efxq5jMgS9p32NKWaE8GzDoNr09JnNU1uundPaWfjcsZDBGUg";
  const loadPreData = async (type) => {
    let sdt = payPeriod && payPeriod?.StartDate;
    let edt = payPeriod && payPeriod?.EndDate;
    setIsLoading(true);
    // setPageLoadCompleted(true)

    if (sdt === undefined || edt === undefined) {
      ///|| check === false uncommented
      return false;
    }
    axios
      .get(`${newBaseURL}/Employee/Timelog/from/${sdt}/to/${edt}`, {
        headers: {
          "Content-type": "application/json",
          Authorization: `Bearer ${sessionStorage.getItem("jwt_access_token")}`,
          Role: "user",
        },
      })
      .then(async (response) => {
        if (response.data.data.length) {
          let prevdata = response.data.data;
          // setEmployeeVerifyFlag(prevdata);
          const sorted = prevdata.sort(
            (a, b) =>
              Date.parse(a.workDate) - Date.parse(b.workDate) ||
              Date.parse(a.workFrom) - Date.parse(b.workFrom)
          );
          let EmployeeProcessPayTimes = sorted;

          if (EmployeeProcessPayTimes.length) {
            let newArray = [];
            let skip = false;
            EmployeeProcessPayTimes.map(async (i, index) => {
              let myID = i.id;

              const rate = 12; // getRateForDate(
              //   amountArray,
              //   moment(i.workDate).format("YYYY-MM-DD"),
              //   price
              // );
              let totalMins = i.totalMinutes;

              let hrCalc = `${Math.floor(totalMins / 60)}:${totalMins % 60}`;
              // newobj[ 'time_from1' ]  = info.start;
              // newobj[ 'time_to1' ]  = info.end;
              // newobj[ 'hrs' ] = HourMinFormat(hrCalc);

              let lableid = `${moment(i.workDate).format("YYYY-MM-DD")}${
                i.payCode
              }${moment(i.workFrom, "HH:mm:ss").format("HH:mm:ss")}`;

              // let payInfo = getCalculatedAmtMin(
              //   i.totalMinutes,
              //   i.payTimeCode ? i.payTimeCode.abberv : "",
              //   i.rate
              // );

              const tagCode =
                i?.TagCode?.split(",").length === 1 &&
                !i?.TagCode?.split(",")[0]
                  ? []
                  : i?.TagCode?.split(",").map((item) => {
                      return {
                        value: item,
                        label: item,
                        jobOrder: i.jobOrder,
                      };
                    });
              let assign = {
                // jobtype: i.Typh,
                jobtype: i.payTimeCode ? i.payTimeCode.abberv : "REG",
                ID: myID,
                EmployeeID: i.employeeID,
                TagCode: tagCode,
                id: lableid,
                date: moment(i.workDate).format("YYYY-MM-DD"),
                time_from: d2Time(i.workFrom),
                time_to: d2Time(i.workTo),
                time_from1: null,
                time_to1: null,
                Rate: i.rate ? i.rate : rate?.price,
                currentProcessStatus: i.currentProcessStatus,
                // payAmount: i.grossAmount ? i.grossAmount : payInfo,
                DetailActing: i.detailActing
                  ? i.detailActing
                  : rate?.DetailActing,
                isNew: true,
                checkDate: i.checkDate,
                // displayPriority:employeeAuthorizedPayTimeCodesList?.find((i) => i?.abberv == i.payTimeCode?.abberv)?.displayPriority,
                displayPriority: i?.payTimeCode?.displayPriority,
                mn: i.totalMinutes,
                dateExceed1: false,

                mn1: 0,
                JObOrdersData: [],
                jobOrder: i.jobOrder ? i.jobOrder : null,
                jobOrder1: i.jobOrder ? i.jobOrder : null,

                code: i.payCode ? i.payCode : "1",

                parentIndex: i.recordNo,
                ignoreadd: true,
                time_to_set: true,
                timekeeper_Status: i.timekeeper_Status,
                appointingAuthority_Status: i.appointingAuthority_Status,
                payrollTech_Status: i.payrollTech_Status,
                supervisor_Status: i.supervisor_Status,
                approvedStatus: i.ApproveStatus,
                certifyingOfficer_Status: i.certifyingOfficer_Status,

                approveTimeFrom: i.approveFromTime
                  ? moment(i.approveFromTime, "HH:mm:ss").utc().format("HH:mm")
                  : null,
                approveTimeTo: i.approveToTime
                  ? moment(i.approveToTime, "HH:mm:ss").utc().format("HH:mm")
                  : null,

                hrs: getHMFromTime(
                  moment(i.workFrom, "HH:mm:ss").format("HH:mm"),
                  moment(i.workTo, "HH:mm:ss").format("HH:mm")
                )?.hhmm,

                rowstatus: i.ConfirmStatus ? i.ConfirmStatus : "Confirm",
                CreatedDate: i.CreatedDate,
                Status: i.Status,
                employee_Status: i.employee_Status,
                donor_Id: i.donor_Id ? i.donor_Id : null,
                Leaveshare_req_id: i.leaveshare_req_id
                  ? i.leaveshare_req_id
                  : null,
                hold: false,
                IsExempt: i.isExempt,

                inspectCommonError: {},
                Ambulance: i.inAmbulance == true ? "TRUE" : null,
                OnCompound: i.onCompund == true ? "TRUE" : null,
                Exposed: i.expose == true ? "TRUE" : null,
                appointingAuthority_name: i.appointingAuthority_name,
                certifyingOfficer_name: i.certifyingOfficer_name,
                payrollTech_name: i.payrollTech_name,
                supervisor_name: i.supervisor_name,
                timekeeper_name: i.timekeeper_name,
              };

              {
                skip = false;
                assign.time_to_set = true;
                newArray.push(assign);
              }
            });
            setIsLoading(false);
            // ------------Rule Check-----------------
            let finaldata = newArray;

            const sorted = finaldata.sort((a, b) => {
              // First, compare the dates
              if (a.date < b.date) return -1;
              if (a.date > b.date) return 1;

              // If dates are the same, compare the time_from
              if (a.time_from < b.time_from) return -1;
              if (a.time_from > b.time_from) return 1;

              if (a.displayPriority < b.displayPriority) return -1;
              if (a.displayPriority > b.displayPriority) return 1;

              // If both date and time_from are the same, the items are considered equal
              return 0;
            });
            setRowsData(sorted);
          } else {
            setIsLoading(false);
            setRowsData([]);
          }
        } else {
          setIsLoading(false);
          setRowsData([]);
        }
      })
      .catch((error) => {
        setIsLoading(false);

        console.warn("Cannot retrieve user data", error);
      });
  };

  useEffect(() => {
    if (payPeriod && userId && price > 0) {
      setRowsData([]);

      loadPreData("AAA1");
    }
  }, [payPeriod, userId, price > 0]);
   
  const columns = [
    { label: "Pay Type", columnName: "jobtype", align: "center" },
    {
      label: "Date",
      columnName: "date",
      type: "date",
      format: "YYYY-MM-DD",
      align: "center",
    },
    {
      label: "From",
      columnName: "time_from",
      type: "time",
      format: "HH:mm",
      align: "center",
    },
    {
      label: "To",
      columnName: "time_to",
      type: "time",
      format: "HH:mm",
      align: "center",
    },
    {
      label: "Hours",
      columnName: "hrs",
      type: "hrs",
      format: "HH:mm",
      align: "center",
    },
    // { label: "Amount", columnName: "payAmount", align: "right", type: "amount", isShow: true },

    {
      label: "Account No",
      columnName: "jobOrder",
      align: "center",
      isShow: true,
    },
  ];

  const handlePrintModal = () => {
    // setPrintLoading(true);

    setTimeout(() => {
      setOpenModalPrint(!openModalPrint);
    }, 500);
  };

  const dataTable = (
    <CommonDataTableTimesheet
      columns={columns}
      data={rowsData}
      payPeriod={payPeriod}
      showSR={true}
    />
  );

  const TimeSheetummary = (
    <table
      className="table paroll-contents-table  "
      style={{
        width: "100%",
        maxWidth: "45%",
        margin: "auto",
        marginTop: "20px",
        marginBottom: "20px",
      }}
    >
      <thead className="paroll-contents-theadnw mb-3">
        <tr>
          <th
            colSpan={3}
            style={{
              textAlign: "center",
              padding: "5px",
              backgroundColor: "white",
              border: "1px solid gainsboro",
            }}
          >
            TimeSheet Summary
          </th>
        </tr>
        <tr>
          <th
            className="paroll-contents-th text-left"
            style={{ textAlign: "left", width: "120px" }}
          >
            <p className="tabletitle labelColor">Pay Type</p>
          </th>
          <th
            className="paroll-contents-th text-right"
            style={{ textAlign: "right", width: "150px" }}
          >
            <p className="tabletitle labelColor">Total Hours</p>
          </th>
          {/* <th
          className="paroll-contents-th text-right"
          style={{ textAlign: "right", width: "200px" }}
        >
          <p className="tabletitle labelColor">Amount($)</p>
        </th> */}
        </tr>
      </thead>
      <tbody className="   paroll-contents-tbodynw" style={{ width: "100%" }}>
        {summary?.map((i, index) => {
          return (
            <tr
              key={index}
              style={{
                marginBottom: 4,
                marginTop: 5,
              }}
            >
              <td className="paroll-contents-td" style={{ textAlign: "left" }}>
                {i.jobtype == "Total" ? (
                  <b>{i.jobtype}</b>
                ) : (
                  `${i.code} - ${i.jobtype}`
                )}
              </td>
              <td
                className="paroll-contents-td "
                style={{ textAlign: "right" }}
              >
                {i.TotalHours
                  ? HourMinLabelFormat(i.TotalHours, false, true)
                  : 0}
                {/* {/ { (HourMinFormat(`${i.TotalHours}:00`)) }  /} */}
              </td>
              {/* <td className="paroll-contents-td" style={{ textAlign: "right" }}>
              {formatAmountDiv(i.Amount, 150)}
            </td> */}
            </tr>
          );
        })}
        <tr
          key={"x"}
          style={{
            marginBottom: 4,
            marginTop: 5,
          }}
        >
          <td className="paroll-contents-td" style={{ textAlign: "left" }}>
            <b> {totalinfo?.jobtype}</b>
          </td>
          <td className="paroll-contents-td" style={{ textAlign: "right" }}>
            <b>
              {totalinfo?.TotalHours
                ? HourMinLabelFormat(totalinfo?.TotalHours, false, true)
                : 0}
            </b>
            {/* {/ { (HourMinFormat(`${i.TotalHours}:00`)) }  /} */}
          </td>
          {/* <td className="paroll-contents-td" style={{ textAlign: "right" }}>
          {formatAmountDiv(totalinfo.Amount, 150, "b")}
        </td> */}
        </tr>
      </tbody>
    </table>
  );

  const TimeSheetummary1 = (
    <div className="gap-16  myStickyDiv">
      <Card elevation={4} className=" p-10  mb-10 ">
      <Grid container spacing={2}>  
        {summary?.map((i) => {
          return (
           
              <Grid item className="mx-1">
                <div className="">
                  <Typography className="text-14 font-semibold pl-2 pt-1 ">
                    <b>{i.code} - {i.jobtype}</b>
                    <span className="textempfweight"> :  {i.TotalHours
                  ? HourMinLabelFormat(i.TotalHours, false, true)
                  : 0}</span>
                  </Typography>
                </div>
              
            </Grid>
          );
        })}
        </Grid>
      </Card>
    </div>
  );

  const reportHeader = (
    <PaybreakModal
      data={{ ...userObject, ...payPeriod, ...{ userId: userId } }}
    />
  );
  return (
    <div className="">
      <div className="row">
        <div className="col-md-5"></div>
      </div>
      <div className="row">
        <div className="col-md-12">
          {/* <pre> */}
          {/* {JSON.stringify(originalData)} */}
          {/* {JSON.stringify(price)} */}
          {/* {JSON.stringify(OTType)} */}
          {/* {JSON.stringify(rowsData)} */}

          {/* {JSON.stringify(hourData)} */}
          {/* </pre> */}

          <Card style={{ width: "100%", margin: "0px" }}>
            {isLoading && <LoadingPanel />}

            <div
              style={{
                width: "100%",
                overflowX: "auto",
              }}
            >
              {rowsData?.length ? (
                <>
                  {TimeSheetummary1}
                  
                  {dataTable}
                  {/* {TimeSheetummary} */}
                </>
              ) : (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "150px",
                  }}
                >
                  <div style={{ display: "block" }}>
                    <div>
                      <Typography
                        className="text-12"
                        style={{ height: "auto" }}
                      >
                        {" "}
                        No records found
                      </Typography>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </Card>
        </div>
      </div>
      {openModalPrint && (
        <div>
          <Modal
            open={openModalPrint}
            onClose={handlePrintModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  margin: "0",
                }}
              >
                <h6 className="mt-2">Time Sheet</h6>
                <div>
                  <div style={{display:"flex"}}>
                    <div>
                    
                    </div>
                    <div>
                    <IconButton onClick={handlePrintModal}>
                    <CloseIcon />
                  </IconButton>
                    </div>
                  </div>
                 
                </div>
              </div>
              <div style={{ maxHeight: "700px", overflow: "scroll" }}>
                <PrintReport
                  rowsData={rowsData}
                  setOpenModal={setOpenModalPrint}
                  dataTable={dataTable}
                  reportHeader={reportHeader}
                  TimeSheetummary={TimeSheetummary}
                  // SignatureView={SignatureView}
                />
              </div>
            </Box>
          </Modal>
        </div>
      )}
    </div>
  );
});

export default PayrollContentVerification;
